/* CleverWipe conversion helpers — delivery estimate, savings calculator, sticky add-to-cart */
(function () {
  'use strict';

  /* ---------- Delivery estimate (business days, skips weekends) ---------- */
  function addBusinessDays(date, days) {
    const d = new Date(date);
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      const day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }
  function fmt(d) {
    return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }
  function initDelivery(root) {
    root.querySelectorAll('[data-te-delivery]').forEach((el) => {
      const min = parseInt(el.dataset.min, 10) || 5;
      const max = parseInt(el.dataset.max, 10) || 9;
      const now = new Date();
      const from = addBusinessDays(now, min);
      const to = addBusinessDays(now, max);
      const out = el.querySelector('[data-te-delivery-range]');
      if (out) out.textContent = fmt(from) + ' – ' + fmt(to);
    });
  }

  /* ---------- Savings calculator ---------- */
  function money(n) {
    return '$' + Math.round(n).toLocaleString('en-US');
  }
  function initCalc(root) {
    root.querySelectorAll('[data-te-calc]').forEach((calc) => {
      if (calc.dataset.ready) return;
      calc.dataset.ready = '1';
      const rolls = calc.querySelector('[data-te-rolls]');
      const price = calc.querySelector('[data-te-price]');
      const kit = parseFloat(calc.dataset.kitPrice) || 0;
      const kitYears = parseFloat(calc.dataset.kitYears) || 1;
      const render = () => {
        const r = parseFloat(rolls.value);
        const p = parseFloat(price.value);
        const yearly = r * p * 12;
        const saved = Math.max(0, yearly - kit / kitYears);
        calc.querySelector('[data-te-rolls-out]').textContent = r;
        calc.querySelector('[data-te-price-out]').textContent = '$' + p.toFixed(2);
        calc.querySelector('[data-te-yearly]').textContent = money(yearly);
        calc.querySelector('[data-te-five]').textContent = money(yearly * 5);
        const savedEl = calc.querySelector('[data-te-saved]');
        if (savedEl) savedEl.textContent = money(saved);
      };
      rolls.addEventListener('input', render);
      price.addEventListener('input', render);
      render();
    });
  }

  /* ---------- Sticky add to cart ---------- */
  function initSticky() {
    const bar = document.querySelector('[data-te-sticky]');
    if (!bar || bar.dataset.ready) return;
    bar.dataset.ready = '1';
    const form = document.querySelector('product-info form[action*="/cart/add"], .product-form form[action*="/cart/add"]');
    const mainBtn = form && form.querySelector('[type="submit"]');
    const stickyBtn = bar.querySelector('[data-te-sticky-btn]');
    if (!form || !mainBtn) {
      bar.remove();
      return;
    }
    stickyBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (mainBtn.disabled) {
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      mainBtn.click();
    });

    const io = new IntersectionObserver(
      (entries) => {
        const e = entries[0];
        const past = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', past);
        bar.setAttribute('aria-hidden', past ? 'false' : 'true');
      },
      { threshold: 0 }
    );
    io.observe(mainBtn);

    const meta = bar.querySelector('[data-te-sticky-meta]');
    const sync = (variant) => {
      if (!variant) return;
      const label = stickyBtn.querySelector('[data-te-sticky-label]');
      if (meta) {
        const fmtMoney = (cents) =>
          (window.Shopify && Shopify.formatMoney)
            ? Shopify.formatMoney(cents)
            : '$' + (cents / 100).toFixed(2);
        meta.textContent = variant.title + ' · ' + fmtMoney(variant.price);
      }
      if (label) label.textContent = variant.available ? label.dataset.add : label.dataset.soldout;
      stickyBtn.disabled = !variant.available;
    };
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => sync(event.data && event.data.variant));
    }
  }


  /* ---------- See it in action videos: play when visible, tap to pause/play ---------- */
  function initVideos(root) {
    root.querySelectorAll('[data-te-videos]').forEach((wrap) => {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      const tiles = wrap.querySelectorAll('[data-te-video-tile]');
      const play = (t) => { const v = t.querySelector('video'); if (!v) return; const p = v.play(); if (p && p.catch) p.catch(() => {}); t.classList.add('is-playing'); };
      const pause = (t) => { const v = t.querySelector('video'); if (!v) return; v.pause(); t.classList.remove('is-playing'); };
      tiles.forEach((t) => {
        t.addEventListener('click', () => { const v = t.querySelector('video'); if (v.paused) { t.dataset.userPaused = ''; play(t); } else { t.dataset.userPaused = '1'; pause(t); } });
      });
      if (!('IntersectionObserver' in window)) { tiles.forEach(play); return; }
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) { if (!e.target.dataset.userPaused) play(e.target); } else { pause(e.target); } });
      }, { threshold: 0.35 });
      tiles.forEach((t) => io.observe(t));
    });
  }

  function init(root) {
    initDelivery(root || document);
    initCalc(root || document);
    initVideos(root || document);
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
